import { Modal } from '@/components';
import { AlgoAuthButton } from '@/modules/account/AlgoAuthButton';
import { LoginButton } from '@/modules/account/LoginButton';
import { isTelegramApp } from '@/utils';

import {
  ReactNode,
  createContext,
  useCallback,
  useContext,
  useState,
} from 'react';
import { useTranslation } from 'react-i18next';

type LoginModalContextType = {
  openLoginModal: (callback?: () => void) => void;
  closeLoginModal: () => void;
};

const LoginModalContext = createContext<LoginModalContextType | null>(null);

export const useLoginModal = () => {
  const context = useContext(LoginModalContext);
  if (!context)
    throw new Error('useLoginModal must be used within LoginModalProvider');
  return context;
};

export const LoginModalProvider = ({ children }: { children: ReactNode }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [afterLoginCallback, setAfterLoginCallback] = useState<() => void>(
    () => {},
  );
  const { t } = useTranslation();

  const openLoginModal = useCallback((callback?: () => void) => {
    setAfterLoginCallback(() => callback || (() => {}));
    setIsOpen(true);
  }, []);

  const closeLoginModal = useCallback(() => {
    setIsOpen(false);
    setAfterLoginCallback(() => {});
  }, []);

  return (
    <LoginModalContext.Provider value={{ openLoginModal, closeLoginModal }}>
      {children}
      {!isTelegramApp() && (
        <Modal isVisible={isOpen} onClose={closeLoginModal} minHeight="auto">
          <br />
          <br />
          <br />

          <LoginButton
            afterLoginCallback={() => {
              afterLoginCallback();
              closeLoginModal();
            }}
          >
            {t('Continue with Google')}
          </LoginButton>
          <br />
          <AlgoAuthButton
            afterLoginCallback={() => {
              afterLoginCallback();
              closeLoginModal();
            }}
          >
            {t('Continue with Algo Wallet')}
          </AlgoAuthButton>

          <br />
          <br />
        </Modal>
      )}
    </LoginModalContext.Provider>
  );
};
